<div class="headline">
    <h1>Ordner Hochladen</h1>
</div>
<ng-container *ngIf="loading|async">
    <app-loading></app-loading>
    <p class="loading-text">{{(loadingText|async)}}</p>
</ng-container>
<ng-container *ngIf="!(loading|async)">
    <ng-container *ngIf="(folders | async).length === 0">
    <div class="drop"
         (dragover)="onDragOver($event)"
         (drop)="onDrop($event)"
    >
        <div class="inner">
            Ordner hinein ziehen
        </div>
    </div>
    </ng-container>
    <ng-container *ngIf="folders | async as folders">
        <div class="tree">
            <ul *ngIf="folders.length !== 0" class="root">
                <ng-container *ngTemplateOutlet="folderTemplate; context: { $implicit: folders }"></ng-container>
            </ul>
        </div>
    </ng-container>
    <ng-template #folderTemplate let-folders>
        <li *ngFor="let folder of folders">
            <fa-icon [icon]="folder.file == null ? 'folder' : 'file'"></fa-icon>
            {{folder.name}}
            <ul *ngIf="folder.children && folder.children.length !== 0">
                <ng-container *ngTemplateOutlet="folderTemplate; context: { $implicit: folder.children }"></ng-container>
            </ul>
        </li>
    </ng-template>
</ng-container>
<div class="buttons">
    <button app-button [Color]="'cancel'" (click)="DialogRef.close()">
        Schließen
    </button>
    <button app-button [Color]="'green'" *ngIf="(folders | async).length !== 0" (click)="upload()">
        Hochladen
    </button>
</div>
